export enum TouchType {
  Visit = "visit",
  PitchDownload = "pitch_download",
  Click = "click",
  MeetingRequest = "meeting_request",
  ContactEmail = "contact_email",
  IntroduceForView = "introduce_for_view",
}
